import { useTheme } from '@automata/mui-theme';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';

export type Props<T> = {
  icon: React.ReactNode;
  label: string;
  handleClickItem: (itemId: T) => void;
  itemId: T;
};

export const SelectionPanelItem = <T extends any>({
  label,
  handleClickItem,
  icon,
  itemId,
}: Props<T>): JSX.Element => {
  const theme = useTheme();

  return (
    <Stack
      onClick={() => handleClickItem(itemId)}
      p={1}
      gap={1}
      borderRadius={1}
      alignItems="center"
      justifyContent="flex-start"
      direction="row"
      bgcolor={theme.palette.grey[100]}
      sx={{
        cursor: 'pointer',
        userSelect: 'none',
        '&:hover': {
          color: theme.palette.common.white,
          backgroundColor: theme.palette.grey[800],
        },
      }}
    >
      {icon}
      <Typography variant="overline">{label}</Typography>
    </Stack>
  );
};
